if (!customElements.get('collection-component')) {
  class Collection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.collectionForm = this.querySelector('.collection-form');
      this.viewToggle = this.querySelector('.collection-view-toggle');
      this.filtersToggle = this.querySelector('#show-filters');
      this.grid = this.querySelector('#collection-grid');

      this.restoreView();

      this.viewToggle?.addEventListener('change', this.handleViewChange.bind(this));
    }

    disconnectedCallback() {
      this.viewToggle?.removeEventListener('change', this.handleViewChange.bind(this));
    }

    restoreView() {
      const saved = localStorage.getItem('collection-view');
      if (saved) {
        const radio = this.querySelector(`#${saved}`);
        if (radio) radio.checked = true;

        if (saved == 'large-view') {
          this.classList.add('large-view');

          this.grid.style.gridTemplateRows = `repeat(${this.querySelectorAll('.collection-product').length}, auto)`
        }
      }
    }

    handleViewChange(e) {
      if (e.target.name === 'collection-view') {
        localStorage.setItem('collection-view', e.target.id);

        document.getElementById('collection-grid').classList.add('opacity-0');
        document.getElementById('collection-grid').addEventListener('transitionend', () => {
          if (e.target.id == 'large-view') {
            this.classList.add('large-view');

            this.grid.style.gridTemplateRows = `repeat(${this.querySelectorAll('.collection-product').length}, auto)`
          } else {
            this.classList.remove('large-view');

            this.grid.style.gridTemplateRows = `repeat(${Math.ceil(this.querySelectorAll('.collection-product').length / 2)}, auto)`
          }

          document.getElementById('collection-grid').classList.remove('opacity-0');
        }, {once: true});
      }
    }
  }

  customElements.define('collection-component', Collection);
}